export default function SEOLinks() {
  const links = [
    { title: 'Корпоративное обучение сотрудников', href: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie', desc: 'Полное руководство по системе обучения персонала: виды, методы, этапы внедрения и оценка эффективности' },
    { title: 'Обучение отдела продаж', href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh', desc: 'Развитие менеджеров по продажам: диагностика, практические тренинги и сопровождение для роста прибыли' },
    { title: 'Обучение персонала', href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala', desc: 'Как построить систему развития сотрудников, которая приносит результат бизнесу' },
    { title: 'Разработка корпоративных программ', href: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya', desc: 'Проектируем систему обучения, которая помогает достигать бизнес-целей' },
    { title: 'Soft Skills', href: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills', desc: 'Развитие гибких навыков: коммуникация, эмоциональный интеллект, работа в команде' },
    { title: 'Командообразование', href: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie', desc: 'Тимбилдинг и развитие командного взаимодействия для бизнес-результатов' },
    { title: 'Адаптация сотрудников', href: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov', desc: 'Onboarding: как новички выходят на плановые показатели в 2 раза быстрее' },
    { title: 'Корпоративная академия', href: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya', desc: 'Как создать систему обучения, которая работает без постоянного участия руководителя' },
    { title: 'Оценка эффективности обучения', href: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya', desc: 'Как измерить ROI и понять, что обучение действительно работает' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-3">
          Все направления корпоративного обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-14 max-w-2xl mx-auto">
          Изучите полный спектр программ для развития вашей команды и бизнеса
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {links.map((link, i) => (
            <a
              key={i}
              href={link.href}
              className="bg-gray-50 p-5 rounded-xl hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group text-center"
            >
              <h3 className="font-semibold text-gray-900 text-sm mb-2 group-hover:text-teal-700 transition-colors">
                {link.title}
              </h3>
              <p className="text-gray-500 text-xs leading-relaxed">{link.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}